import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React from 'react';
import { deleteButton } from "../../assets/icons";
import './tag.scss';
import PropTypes from 'prop-types';

const TagNew = ({ label, onRemove }) => {
    const onDeleteTag = () => onRemove(label);
    return (
        <div className={"tag-container"}>
            <div className="tag-text-container">
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 50 }}
                    overlay={
                        <Tooltip className="tag-popup">
                            {label}
                        </Tooltip>
                    }
                >
                    <span className="tag-text">
                        {label}
                    </span>
                </OverlayTrigger>
            </div>
            {   onRemove &&
                <div className="remove-tag-btn" onClick={onDeleteTag}>
                    <img src={deleteButton} alt={"Remove tag"} className="remove-tag"/>
                </div>
            }
        </div>
    )
}

TagNew.propTypes = {
    label: PropTypes.string,
    onRemove: PropTypes.func
};

export default TagNew;
